module.exports = __webpack_public_path__ + "static/media/25542699_1703514383057079_2361279951976018390_o.9436ab2d.jpg";